import './Cart.css';

import { IonBadge, IonButton, IonIcon } from '@ionic/react';
import { bagHandleOutline } from 'ionicons/icons';
import { useEffect, useState } from 'react';

interface Props {
    change?: number
}

const Cart: React.FC<Props> = (props) => {
    const [total, setTotal] = useState(window.cartTotal)

    useEffect(() => {
        setTotal(window.cartTotal)
    }, [window.cartTotal, props.change])

    return <div className="cart-quantity">
        <IonButton routerLink="/cart" shape="round" color="white">
            <IonIcon icon={bagHandleOutline}/>
            {total! > 0 ? <IonBadge className="badge" color="danger">{total}</IonBadge> : null}
        </IonButton>
    </div>;
}

export default Cart